module.exports = __webpack_public_path__ + "static/media/tcs.23848555.jpeg";